<template>
  <div class="uk-overflow-auto">
    <div class="uk-container uk-margin-top">
      <FilterSelector
        :options="drivers"
        label="fullName"
        @select="selectDriver"
      >
      </FilterSelector>
    </div>

    <table class="uk-table uk-table-hover uk-table-middle uk-table-divider">
      <tbody>
        <tr v-for="(chat, chatIdx) in chats" :key="chatIdx">
          <td>
            <p class="uk-margin-remove">
              <strong>{{ chat.driver.displayName }}</strong>
            </p>
            <p class="uk-text-meta uk-margin-small">
              {{ chat.latestMessage.text }}
            </p>
          </td>
          <td>
            <p></p>
          </td>
          <td class="uk-text-truncate">02/20/20</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
// import Button from '@/components/core/Button.vue';
import FilterSelector from '@/components/core/FilterSelector.vue';
import DriversQuery from '@/gql/drivers/Drivers.gql';
import CompanyQuery from '@/gql/company/Company.gql';
import { db, collection, addDoc} from './db';
import { Company, Driver } from '../../types';

export default defineComponent({
  data() {
    return { drivers: [], chats: [] as any, company: {} as Company | any };
  },
  components: {
    // Button,
    FilterSelector,
  },
  firestore: {
    chats: collection(db, 'Chats')
  },
  methods: {
    selectDriver(driver: Driver) {
      const driverChats = this.chats.filter(
        (chat) => chat.driver.id === driver.id,
      );

      if (driverChats.length === 0) {
        const chatsCollectionRef = collection(db, 'Chats');

        const newChatPromise = addDoc(chatsCollectionRef, {
            company: { id: this.company.id, displayName: this.company.name },
            driver: { id: driver.id, displayName: driver.fullName },
            latestMessage: {
                createdAt: null,
                text: null,
            },
        }).then((doc) => {
            this.$emit('selectChat', doc.id);
        });
      } else {
        this.$emit('selectChat', driverChats[0].id);
      }
    },
  },
  apollo: {
    drivers: {
      query: DriversQuery,
    },
    company: {
      query: CompanyQuery,
    },
  },
});
</script>